import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useGlobalContext } from "../Config";
import ProductosDisponiblesTable from "../components/ProductosDisponiblesTable";
import UseScrollOnStateChange from "../components/UseScrollOnStateChange";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom"; // Use useLocation to get the current URL
import Loader from "../components/Loader";
import { ProgressBar } from "primereact/progressbar";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Calendar } from "primereact/calendar";
import FormCrearListaEspera from "../components/FormCrearListaEspera";

const AgregarProducto = (props) => {
  const [displayDialog, setDisplayDialog] = useState(false);
  const [tipoProductoTouched, setTipoProductoTouched] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idCliente = parseInt(searchParams.get("idCliente"));
  const idCotizacion = parseInt(searchParams.get("idCotizacion"));
  const selected = searchParams.get("selected");
  const desdeParam = searchParams.get("desde");
  const hastaParam = searchParams.get("hasta");
  const [desde, setDesde] = useState(desdeParam ? new Date(desdeParam) : null);
  const [hasta, setHasta] = useState(hastaParam ? new Date(hastaParam) : null);
  const [carro, setCarro] = useState([]);
  const [cliente, setCliente] = useState(null);
  const { baseUrl } = useGlobalContext();
  const [empresa, setEmpresa] = useState("TODAS");
  const empresas = [
    { name: "TODAS", value: "TODAS" },
    { name: "ALTAMIRA", value: "Altamira" },
    { name: "LA SIEMBRA", value: "LA SIEMBRA" },
  ];
  const [showProductosEncontrados, setShowProductosEncontrados] = useState(false);
  const [tipoProducto, setTipoProducto] = useState("");
  const [tiposProducto, setTiposProducto] = useState([
    { id: 1, descripcion: "Bodega", code: "Bodega", cobro: "Factura Exenta" },
    { id: 2, descripcion: "Sitio", code: "Sitio", cobro: "Factura Exenta" },
    { id: 3, descripcion: "Casino", code: "Casino", cobro: "Factura Exenta" },
    {
      id: 4,
      descripcion: "Zona Lavado",
      code: "Zona Lavado",
      cobro: "Factura Exenta",
    },
  ]);
  const navigate = useNavigate();

  
  const [rowClick, setRowClick] = useState(true);

  const [loading, setLoading] = useState(false);
  const [productosDisponibles, setProductosDisponibles] = useState([]);
  const [displayConstruccion, setDisplayConstruccion] = useState(false);

  const searchProductos = async () => {
    try {
      if (!isValidFiltrosProductos()) {
        return;
      }

      resetCarro();
      setProductosDisponibles([]);
      const empresasArray = mapEmpresas(empresa);
      const tiposArray = mapTipos(tipoProducto);
      const { desdeFiltro, hastaFiltro } = mapDateFilters(desde, hasta);
      // Convertir las fechas a formato ISO
      //const desdeFiltro = desde ? desde.toISOString().split('T')[0] : '';
      //const hastaFiltro = hasta ? hasta.toISOString().split('T')[0] : '';
      setLoading(true);
      setShowProductosEncontrados(true);

      const url = buildProductosUrl(
        empresasArray,
        desdeFiltro,
        hastaFiltro,
        tiposArray
      );
      const data = await fetchData(url);
      handleProductosResponse(data);
    } catch (error) {
      console.error(error);
    }
  };

  const isValidFiltrosProductos = () => {
    if (!checkCabeceraFiltrosProductos()) {
      return false;
    }
    return true;
  };

  const checkCabeceraFiltrosProductos = () => {
    const basicChecks =
      empresa !== null &&
      empresa !== undefined &&
      empresa !== "" &&
      tipoProducto !== null &&
      tipoProducto !== undefined &&
      tipoProducto !== "" &&
      desde !== null &&
      desde !== undefined &&
      hasta !== null &&
      hasta !== undefined;

    // Validación de fechas
    if (!basicChecks) {
      alert("Debe ingresar todos los parámetros de búsqueda");
      return false;
    }

    // Validar que hasta no sea menor a desde
    if (hasta < desde) {
      alert("La fecha de término no puede ser menor a la fecha de inicio");
      return false;
    }

    // Validar que las fechas no sean menores a hoy
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    
    if (desde < currentDate) {
      alert("La fecha de inicio no puede ser menor a la fecha actual");
      return false;
    }

    return true;
  };

  const mapEmpresas = (selectedEmpresa) => {
    const empresaMapping = {
      TODAS: ["2", "3"],
      ALTAMIRA: ["2"],
      "LA SIEMBRA": ["3"],
    };
    return empresaMapping[selectedEmpresa.toUpperCase()] || [];
  };

  const mapTipos = (tipoProductoArray) => {
    return tipoProductoArray.map((tipo) => tipo.descripcion);
  };
  const buildProductosUrl = (
    empresasArray,
    desdeFiltro,
    hastaFiltro,
    tiposArray
  ) => {
    return `${baseUrl}getProductosByFiltro?empresas=${empresasArray}&fechaInicio=${desdeFiltro}&fechaTermino=${hastaFiltro}&tipos=${tiposArray}`;
  };

  const handleProductosResponse = (data) => {
    if (Array.isArray(data.productos)) {
      setProductosDisponibles(data.productos);
      setLoading(false);
    } else {
      console.error("Data.clientes no es array:", data.clientes);
      setLoading(false);
    }
  };

  const mapDateFilters = (desde, hasta) => {
    const dateObjectDesde = new Date(desde);
    const dateObjectHasta = new Date(hasta);
    const desdeFiltro = dateObjectDesde.toISOString().split("T")[0];
    const hastaFiltro = dateObjectHasta.toISOString().split("T")[0];
    setDesdeFiltro(desdeFiltro);
    setHastaFiltro(hastaFiltro);

    return { desdeFiltro, hastaFiltro };
  };

  const [desdeFiltro, setDesdeFiltro] = useState("");
  const [hastaFiltro, setHastaFiltro] = useState("");

  const resetCarro = () => {
    setCarro([]);
  };

  const fetchDataCliente = async () => {
    try {
      const response = await fetch(
        `${baseUrl}getClienteById?idCliente=${idCliente}`
      );
      if (!response.ok) {
        throw new Error(
          `Network response was not ok. Status: ${response.status}`
        );
      }
      const data = await response.json();
      setCliente(data);
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };
  const fetchData = async (url) => {
    const requestOptions = {
      method: "GET",
      headers: new Headers(),
      redirect: "follow",
    };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(
        `Network response was not ok. Status: ${response.status}`
      );
    }

    return response.json();
  };
  useEffect(() => {
    if (idCliente) {
      fetchDataCliente();
    }
  }, [idCliente, selected]);

  const selectSubProductsAndServices = () => {
    if (carro.length <= 0) {
      alert("Seleccione al menos un producto");
    } else {
      // Update each item in carro to include tarifa_base attribute
      const updatedCarro = carro.map((item) => ({
        ...item,
        tarifa_base: item.tarifa_base,
      }));

      const carroEncoded = encodeURIComponent(JSON.stringify(updatedCarro));

      const newURL = `/selectSubProductosYServicios?activeIndex=2&selectedItems=${carroEncoded}&idCliente=${cliente.id}&selected=true&desde=${desdeFiltro}&hasta=${hastaFiltro}&idCotizacion=${idCotizacion}&adicional=true`;
      navigate(newURL, {
        state: {
          isFormAgregarProducto: true,
        },
      });
    }
  };
  UseScrollOnStateChange(productosDisponibles, "productosDataTable");
  const getTipoProductoByEmpresa = async (empresa) => {
    try {
      const url = `${baseUrl}getTiposProductoByEmpresa?empresa=${empresa}`;
      const data = await fetchData(url);
      handleTiposProductoResponse(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleTiposProductoResponse = (data) => {
    if (Array.isArray(data.tiposProductos)) {
      setTiposProducto(data.tiposProductos);
    } else {
      console.error("Data received is not an array");
    }
  };
  useEffect(() => {
    getTipoProductoByEmpresa("TODAS");
  }, []);

  const today = new Date();

  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const tomorrowHasta = new Date(today);
  tomorrowHasta.setDate(tomorrowHasta.getDate() + 2);

  return (
    <div className="card">
      {cliente && (
        // <FormBusquedaProductos
        //   baseUrl={baseUrl}
        //   cliente={cliente}
        //   empresa={empresa}
        //   setEmpresa={setEmpresa}
        //   empresas={empresas}
        //   tipoProducto={tipoProducto}
        //   setTipoProducto={setTipoProducto}
        //   tiposProducto={tiposProducto}
        //   setTiposProducto={setTiposProducto}
        //   desde={desde}
        //   setDesde={setDesde}
        //   hasta={hasta}
        //   setHasta={setHasta}
        //   searchProductos={searchProductos}
        //   idCotizacion={idCotizacion}
        // />
        <>
          <Button
            label="Volver a la Asignación"
            icon="pi pi-arrow-left"
            rounded 
            outlined 
            onClick={() => {
              navigate(
                  `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desde}&hasta=${hasta}`
                );
            }}
            className="p-button mt-4 mb-4 p-button-rounded"
          />
          <ProgressBar value="100" showValue={false} className="mt-2 mb-4" />
          
          {/* Bloque de datos del cliente */}
          <div className="p-fluid formgrid grid" id="clienteSeleccionado">
            <div className="field col-12 md:col-2">
              <h5 htmlFor="firstname2" style={{ color: "green" }}>
                Información del Cliente
              </h5>
            </div>
            <div className="field col-12 md:col-2">
              <label htmlFor="firstname2">RUT</label>
              <h6>{`${cliente.rut}`}</h6>
            </div>
            <div className="field col-12 md:col-2">
              <label htmlFor="firstname2">Razón Social</label>

              <h6>{`${cliente.razon_social}`}</h6>
            </div>
            <div className="field col-12 md:col-2">
              <label htmlFor="firstname2">Nombre de empresa</label>
              <h6>{`${cliente.nombre}`}</h6>
            </div>
          </div>
          <ProgressBar value="100" showValue={false} className="mt-2 mb-4" />
     
          {/* Bloque de formulario cliente */}
          <h4 style={{ marginBottom: "5px" }}>
            Agregue productos a la cotización #{idCotizacion}
          </h4>
          <h6 style={{ marginTop: "5px" }}>
            Complete los filtros: empresa, tipo de producto y fechas
          </h6>
          <div className="p-fluid formgrid grid" style={{ marginTop: "20px" }}>
            {/* CAMPO DE EMPRESA */}
            <div className="field col-12 md:col-6">
              <label htmlFor="firstname2">Empresa</label>
              <Dropdown
                id="state"
                value={empresa}
                onChange={async (e) => {
                  setEmpresa(e.value);
                  setTipoProducto("");
                  try {
                    await getTipoProductoByEmpresa(e.value);
                  } catch (error) {
                    console.error("Error occurred:", error);
                  }
                }}
                options={empresas}
                optionLabel="name"
                placeholder="Seleccione Empresa"
                filter
              ></Dropdown>
            </div>
            {/* CAMPOS TIPO PRODUCTO */}
            <div className="field col-12 md:col-6">
              <label htmlFor="tipoproducto">Tipo Producto</label>
              <MultiSelect
                id="tipoproducto"
                value={tipoProducto}
                onChange={(e) => {
                  setTipoProducto(e.value);
                  setTipoProductoTouched(true);
                }}
                onBlur={() => setTipoProductoTouched(true)}
                options={tiposProducto
                  .filter(
                    (option, index, self) =>
                      index ===
                      self.findIndex(
                        (t) => t.descripcion === option.descripcion
                      )
                  )
                  .map((option) => ({
                    ...option,
                    label: `${option.descripcion}`,
                  }))}
                optionLabel="label"
                placeholder="Seleccione Tipo Producto"
                filter
                required
                className={!tipoProducto || tipoProducto.length === 0 || tipoProductoTouched ? 'p-invalid' : ''}
              ></MultiSelect>
                {(!tipoProducto || tipoProducto.length === 0) && tipoProductoTouched && (
              <small className="p-error">El tipo de producto es obligatorio</small>
            )}
            </div>

            {/* CAMPOS FECHAS */}
            <div className="field col-12 md:col-6">
              <label htmlFor="firstname2">Fecha Desde</label>
              <Calendar
                dateFormat="dd/mm/yy"
                showIcon
                showButtonBar
                onChange={(e) => {
                  setDesde(e.value);
                  // Si la fecha hasta es menor que la nueva fecha desde, actualizar hasta
                  if (hasta && e.value && hasta < e.value) {
                    setHasta(e.value);
                  }
                }}
                minDate={tomorrow}
                placeholder="Seleccione una fecha"
              ></Calendar>
            </div>

            <div className="field col-12 md:col-6">
              <label htmlFor="lastname2">Fecha Hasta</label>
              <Calendar
                dateFormat="dd/mm/yy"
                showIcon
                showButtonBar
                onChange={(e) => setHasta(e.value)}
                minDate={tomorrowHasta}
                placeholder="Seleccione una fecha"
              />
            </div>

            <div
              className="field col-12 md:col-12"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {" "}
              <Button
                label="Buscar Productos"
                icon="pi pi-search"
                className="p-button-primary mt-4 mb-4 p-button-rounded"
                onClick={() => {
                  searchProductos();
                }}
                style={{ width: "400px" }}
                raised
              />
            </div>
          </div>
        </>
      )}
      {showProductosEncontrados && (
        <>
          {loading ? (
            <>
              <Loader></Loader>
            </>
          ) : (
              
            <div className="field col-12 md:col-12">

              <div className="field col-12 md:col-12 flex justify-between items-center">
                <h5 className="text-gray-800 text-base font-medium m-0">
                  ¿Cuáles productos desea?
                </h5>
                
                <Button
                  type="button"
                  onClick={() => setDisplayDialog(true)}
                  className="ml-2 text-blue-600 text-sm hover:underline focus:outline-none focus:ring-2 focus:ring-blue-500 rounded transition"
                >
                  ¿No encuentras el producto que buscas? Solicítalo en lista de espera.
                </Button>
              </div>

              <ProductosDisponiblesTable
                productosDisponibles={productosDisponibles}
                loading2={loading}
                rowClick={rowClick}
                carro={carro}
                setCarro={setCarro}
                desdeFiltro={desdeFiltro}
                hastaFiltro={hastaFiltro}
                setDisplayConstruccion={setDisplayConstruccion}
                displayConstruccion={displayConstruccion}
              />
            </div>
          )}

          <div
            className="field col-12 md:col-12"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              label="Agregar"
              icon="pi pi-plus"
              className="mt-4 mb-4 p-button-rounded p-button-success"
              onClick={selectSubProductsAndServices}
              style={{ width: "400px" }}
              visible={!loading}
              raised
            />
          </div>
          <FormCrearListaEspera
            visible={displayDialog}
            onHide={() => setDisplayDialog(false)}
            idCliente={idCliente}
            setDisplayDialog={setDisplayDialog}
            empresa={empresa}
            setEmpresa={setEmpresa}
            empresas={empresas}
            tipoProducto={tipoProducto}
            setTipoProducto={setTipoProducto}
            tiposProducto={tiposProducto}
            setTiposProducto={setTiposProducto}
            baseUrl={baseUrl}
          />
        </>
      )}
    </div>
  );
};

export default AgregarProducto;
